/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import './Location.css'
import { GoLocation } from "react-icons/go";
import { TfiTimer } from "react-icons/tfi";
import { AiOutlineMobile } from "react-icons/ai";
//import { Link } from 'react-router-dom';



const Location = () => {
    return (
        <div>
            <div className="main-contact py-20">
                <div className="imgs p-4">
                 <img src="https://petermason.themerex.net/wp-content/uploads/2016/11/background-17.jpg" alt="" />
                 <div className='mapouter'><div class="gmap_canvas"><iframe width="100%" height="100%" id="gmap_canvas" src="https://maps.google.com/maps?q=eskaton road&t=&z=15&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>
                </div>
                <div className="contact-info p-4">
                    <h1>CONTACT INFO</h1>
                    <p className='py-5 mt-8'>Have a question? Our team always ready to help. Feel free and come to us anytime, we are glad to see you at our studio.</p>
                    <div className="flex py-1">
                    <span className='mt-8'> <GoLocation /></span> 
                    <p className='mt-6 mx-4'>  2277 Lorem Ave., San Diego, CA 22553</p>
                    </div>
                       <div className="flex">
                        <span className='mt-4 '><TfiTimer /></span>
                         <p className='py-2 mx-4'>Monday - Friday: 10 am - 10pm</p>                        
                       </div>
                        <p className='mx-8'>Sunday: 11 am - 9pm</p>  
                    <div className="flex py-4">
                        <span className='mt-4'>< AiOutlineMobile /></span>
                        <p className='py-2 mx-5'>123 - 456 - 7890   </p> 
                    </div>
                   
 
                </div>
            </div>
        </div>
    );
};

export default Location;